import { CarrierSubmissionClient } from 'clients';
import { QueryKeys } from 'enums';
import { CarrierSubmission, CarrierSubmissionSearchFilter, CarrierSubmissionSearchItem } from 'types';
import { UseQueryBaseRetrieveOptions, UseQueryBaseSearchOptions } from './query/types';
import { useQueryRetrieve, useQuerySearch } from './query/useQuery';

export function useRetrieveCarrierSubmission(props: UseQueryBaseRetrieveOptions<CarrierSubmission>) {
  const { id, queryOptions, enabled } = props;
  return useQueryRetrieve<CarrierSubmissionSearchItem, CarrierSubmissionSearchItem, CarrierSubmissionClient>({
    queryKey: QueryKeys.CarrierSubmission,
    clientClass: CarrierSubmissionClient,
    id,
    enabled,
    queryOptions,
  });
}

export function useSearchCarrierSubmissions(
  props: UseQueryBaseSearchOptions<CarrierSubmissionSearchItem, CarrierSubmissionSearchFilter> = {},
) {
  const { filter, queryOptions, enabled } = props;
  return useQuerySearch<
    CarrierSubmissionSearchItem,
    CarrierSubmissionSearchItem,
    CarrierSubmissionClient,
    CarrierSubmissionSearchFilter
  >({
    queryKey: QueryKeys.CarrierSubmissions,
    clientClass: CarrierSubmissionClient,
    enabled,
    filter,
    queryOptions,
  });
}
